import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Spotify = ({featuredProjectsList}) => {
  const project = getProject('spotify');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '226423099'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Together with the Label Relations team we created an extendable
            platform tool for Spotify to highlight new releases, milestones, or
            just celebrate artists and their fans.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170724162216/01-Intro2.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170721093230/02-Kent-Look-_-Feel1.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170721093242/03-Kent1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="cities-go-head-to-head">Cities go head to head</h2>
          <p>
            Debates are settled once and for all as fans are finally able to see
            which city is home to the biggest fans, which city the artists are
            most popular in, and get insight into each city’s taste.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170721093253/04-Regional-Insights1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="turning-data-into-insights">Turning data into insights</h2>
          <p>
            Not only are fans able to see how much they have listened, but
            they’re also able to get deeper insights into what listening habits
            they have, how they compare to other listeners, which member they
            resemble based on their taste, as well as visualizing their behavior
            with an interactive listening signature.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170721093302/05-Listening-Data-_-Habits1.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170721093427/06-DD-Insights1.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170721093415/07-Listening-Signature1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="bragging-rights">Bragging rights</h2>
          <p>
            Passionate fans can show the world their stats, such as listening to
            an artist for 500+ hours or earning the coveted title of a superfan
            by ranking in the top 1% of fans, or that they are a die hard fan
            because their most streamed track is an obscure b-side that you’ve
            probably never heard. This through personalized and instantly
            generated share-cards.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170721093437/08-Share-Cards1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="in-short">In short</h2>
          <p>
            All personalised data and statistics are available to share and as a
            final takeaway the users are presented with a full page summary of
            their fandom. The most shared section of the platform.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170721093451/09-Summaries1.jpg'
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Collaborative Working Sessions',
                  'Creative Strategy',
                  'Product Strategy',
                  'Technical Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'Motion Design',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Front-end Development',
                  'Systems Architecture',
                  'WebGL'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Analytics & Insights',
                  'Launch',
                  'Monitoring',
                  'Optimization',
                  'Quality Assurance'
                ]
              },

              {
                title: 'Content',
                items: ['Copywriting']
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Spotify;
